import {Component, Injector} from '@angular/core';
import {OrderState, Store as OrderStore} from './state/store';
import {Order} from './state/model';
import {OrderService as OrderService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {OrderQuery} from './state/query';
import {FieldConfig} from "../../components/form/field.interface";
import {of} from "rxjs";
import * as moment from 'moment';
import {first, shareReplay} from "rxjs/operators";

@Component({
  templateUrl: 'export.html',
  styleUrls: ['export.scss']
})
export class ExcelExportComponent {

  name = 'Rendelések exportálása';
  group: FormGroup;
  field: FieldConfig = FieldConfig.create({
    label: of('Időszak'),
    name: "range",
    type: ""
  });

  constructor(
    public injector: Injector,
    private service: OrderService,
    protected formBuilder: FormBuilder) {

    this.group = formBuilder.group({});

    this.group.addControl('rangeFrom', formBuilder.control(''));
    this.group.addControl('rangeTo', formBuilder.control(''));

  }

  exportXls() {

    this.service.export$({
      from: moment(this.group.get('rangeFrom').value).toISOString(),
      to: moment(this.group.get('rangeTo').value).toISOString(),
    }).pipe(
      first(),
      shareReplay(1),
    )
      .subscribe();
  }
}
